/* assets/j_cart-rewards.js
   NJC mini cart rewards.
   Requires assets/j_cart-core.js.
*/

(function () {
  if (window.__j_cart_rewards_active) return;
  window.__j_cart_rewards_active = true;

  var refreshTimer = null;
  var isSyncing = false;

  function getWrap() {
    return document.querySelector('[data-j-cart-rewards]');
  }

  function parseConfig(wrap) {
    try {
      return JSON.parse(wrap.getAttribute('data-config') || '{}');
    } catch (e) {
      return {};
    }
  }

  function getEls() {
    var wrap = getWrap();
    if (!wrap) return null;

    return {
      wrap: wrap,
      fill: wrap.querySelector('[data-j-rewards-fill]'),
      bar: wrap.querySelector('[data-j-rewards-bar]'),
      markers: wrap.querySelector('[data-j-rewards-markers]'),
      labels: wrap.querySelector('[data-j-rewards-labels]'),
      msg: wrap.querySelector('[data-j-rewards-msg]'),
      offers: wrap.querySelector('[data-j-reward-offers]'),
      config: parseConfig(wrap)
    };
  }

  function formatMoney(cents) {
    if (window.JCartCore && window.JCartCore.formatMoney) {
      return window.JCartCore.formatMoney(cents);
    }

    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function formatMoneyShort(cents) {
    return formatMoney(cents).replace('.00', '');
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getActiveDiscountCode() {
    var key = 'njc_active_discount_code';
    var params = new URLSearchParams(window.location.search);
    var code = params.get('discount_code') || params.get('discount') || '';
    var stored = '';

    try {
      stored = sessionStorage.getItem(key) || '';
    } catch (e) {}

    if (code) {
      code = String(code).trim().toUpperCase();

      try {
        sessionStorage.setItem(key, code);
      } catch (e2) {}

      return code;
    }

    return String(stored || '').trim().toUpperCase();
  }

  function isExcludedByDiscount(config) {
    var excluded = String(config.excluded_discount_code || '').trim().toUpperCase();
    if (!excluded) return false;

    return getActiveDiscountCode() === excluded;
  }

  function isTrue(value) {
    return value === true || value === 1 || value === '1' || value === 'true';
  }

  function isRewardLine(item) {
    var props = item && item.properties ? item.properties : {};

    return (
      isTrue(props._j_reward) ||
      isTrue(props._reward1) ||
      isTrue(props._reward2) ||
      isTrue(props._reward3) ||
      isTrue(props._mystery) ||
      isTrue(props._premium)
    );
  }

  function isPromoLine(item) {
    var props = item && item.properties ? item.properties : {};

    return (
      isRewardLine(item) ||
      isTrue(props._j_auto_gift) ||
      isTrue(props._j_exclusive_gift) ||
      isTrue(props._jcg_gift)
    );
  }

  function getSpendSubtotal(cart) {
    var sum = 0;

    (cart.items || []).forEach(function (item) {
      if (isPromoLine(item)) return;
      sum += Number(item.line_price || 0);
    });

    return sum;
  }

  function getProductSkus(product) {
    var skus = [];

    if (!product || !product.variants) return skus;

    product.variants.forEach(function (variant) {
      if (!variant || !variant.sku) return;
      skus.push(String(variant.sku).trim().toUpperCase());
    });

    return skus;
  }

  function cartHasProductSku(cart, product) {
    var productSkus = getProductSkus(product);

    if (!productSkus.length) return false;

    return (cart.items || []).some(function (item) {
      var itemSku = String(item.sku || '').trim().toUpperCase();

      if (isRewardLine(item)) return false;
      if (!itemSku) return false;

      return productSkus.indexOf(itemSku) !== -1;
    });
  }

  function rewardInCart(cart, reward) {
    return (cart.items || []).some(function (item) {
      var props = item.properties || {};

      return (
        isRewardLine(item) &&
        (
          props._j_reward_key === reward.key ||
          props._j_reward_flag === reward.flag ||
          isTrue(props[reward.flag])
        )
      );
    });
  }

  function getActiveSteps(config) {
    var steps = [];

    if (config.free_shipping && config.free_shipping.enabled === true && Number(config.free_shipping.amount || 0) > 0) {
      steps.push({
        key: 'free_shipping',
        type: 'shipping',
        label: config.free_shipping.label || 'FREE SHIPPING',
        amount: Number(config.free_shipping.amount || 0),
        icon_off: config.free_shipping.icon_off || '',
        icon_on: config.free_shipping.icon_on || ''
      });
    }

    (config.rewards || []).forEach(function (reward) {
      if (!reward || reward.enabled !== true || Number(reward.amount || 0) <= 0) return;

      steps.push({
        key: reward.key,
        type: 'reward',
        label: reward.label || 'REWARD',
        amount: Number(reward.amount || 0),
        icon_off: reward.icon_off || '',
        icon_on: reward.icon_on || ''
      });
    });

    return steps.sort(function (a, b) {
      return a.amount - b.amount;
    });
  }

  function getProgress(total, config) {
    var steps = getActiveSteps(config);
    var count = steps.length;
    var firstPos;
    var lastPos;
    var i;
    var prevStep;
    var nextStep;
    var prevPos;
    var nextPos;
    var ratio;

    if (!count) return 0;

    if (count === 1) {
      return total >= Number(steps[0].amount || 0) ? 50 : Math.max(0, Math.min(50, total / Number(steps[0].amount || 1) * 50));
    }

    firstPos = 8;
    lastPos = 92;

    if (total < Number(steps[0].amount || 0)) {
      return Math.max(0, Math.min(firstPos, total / Number(steps[0].amount || 1) * firstPos));
    }

    for (i = 1; i < count; i++) {
      prevStep = steps[i - 1];
      nextStep = steps[i];

      if (total < Number(nextStep.amount || 0)) {
        prevPos = firstPos + ((i - 1) * ((lastPos - firstPos) / (count - 1)));
        nextPos = firstPos + (i * ((lastPos - firstPos) / (count - 1)));
        ratio = (total - Number(prevStep.amount || 0)) / (Number(nextStep.amount || 0) - Number(prevStep.amount || 0));

        return prevPos + Math.max(0, Math.min(1, ratio)) * (nextPos - prevPos);
      }
    }

    return 100;
  }

  function getNextStep(total, config) {
    var steps = getActiveSteps(config);

    for (var i = 0; i < steps.length; i++) {
      if (total < steps[i].amount) return steps[i];
    }

    return null;
  }

  function getFirstAvailableVariant(product) {
    var variants = product && product.variants ? product.variants : [];

    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available === true) return variants[i];
    }

    return null;
  }

  function selectRewardProduct(reward, cart) {
    var products = reward.products || [];
    var product;
    var variant;

    for (var i = 0; i < products.length; i++) {
      product = products[i];

      if (!product) continue;

      variant = getFirstAvailableVariant(product);
      if (!variant) continue;

      if (reward.allow_duplicate !== true && cartHasProductSku(cart, product)) {
        continue;
      }

      return product;
    }

    return null;
  }

  function renderText(template, product, variant) {
    var html = String(template || '');

    html = html.replace(/%product%/gi, escapeHtml(product.title || ''));
    html = html.replace(/%price%/gi, formatMoney((variant && variant.price) || 0));

    return html;
  }

  function renderMarkers(total, els) {
    var steps;
    var count;
    var markerHtml = '';
    var labelHtml = '';

    if (!els.markers || !els.labels || !els.bar) return;

    steps = getActiveSteps(els.config);
    count = steps.length;

    if (!count) {
      els.bar.style.display = 'none';
      els.markers.innerHTML = '';
      els.labels.innerHTML = '';
      return;
    }

    els.bar.style.display = '';

    steps.forEach(function (step, index) {
      var left = count === 1 ? 50 : 8 + (index * (84 / (count - 1)));
      var isMet = total >= step.amount;
      var icon = isMet ? step.icon_on : step.icon_off;

      markerHtml += ''
        + '<div class="j_cart-rewards__marker' + (isMet ? ' is-met' : '') + '" style="left:' + left + '%">'
        +   '<span class="j_cart-rewards__dot">'
        +     (icon ? '<img class="j_cart-rewards__icon" src="' + escapeHtml(icon) + '" alt="' + escapeHtml(step.label) + '" width="22" height="22">' : '')
        +   '</span>'
        + '</div>';

      labelHtml += ''
        + '<div class="j_cart-rewards__label' + (isMet ? ' is-met' : '') + '" style="left:' + left + '%">'
        +   escapeHtml(step.label)
        + '</div>';
    });

    els.markers.innerHTML = markerHtml;
    els.labels.innerHTML = labelHtml;
  }

  function renderVariantOptions(product) {
    var variants = product && product.variants ? product.variants : [];
    var options = '';
    var firstAvailable = getFirstAvailableVariant(product);

    if (variants.length <= 1) return '';

    variants.forEach(function (variant) {
      var selected = firstAvailable && String(firstAvailable.id) === String(variant.id) ? ' selected' : '';
      var disabled = variant.available === true ? '' : ' disabled';

      options += ''
        + '<option value="' + escapeHtml(variant.id) + '"' + selected + disabled + '>'
        + escapeHtml(variant.title)
        + '</option>';
    });

    return ''
      + '<select class="j_cart-rewards__select" data-j-reward-variant>'
      + options
      + '</select>';
  }

  function renderOffers(cart, total, els) {
    var html = '';

    if (!els.offers) return;

    (els.config.rewards || []).forEach(function (reward) {
      var product;
      var variant;

      if (!reward || reward.enabled !== true) return;
      if (Number(reward.amount || 0) <= 0) return;
      if (total < Number(reward.amount || 0)) return;
      if (rewardInCart(cart, reward)) return;

      product = selectRewardProduct(reward, cart);
      if (!product) return;

      variant = getFirstAvailableVariant(product);
      if (!variant) return;

      html += ''
        + '<div class="j_cart-rewards__offer" data-j-reward-card="' + escapeHtml(reward.key) + '">'
        +   '<img class="j_cart-rewards__img" src="' + escapeHtml(product.image || '') + '" width="80" height="80" alt="' + escapeHtml(product.title || '') + '" loading="lazy">'
        +   '<div class="j_cart-rewards__info">'
        +     '<div class="j_cart-rewards__title">' + escapeHtml(product.title || '') + '</div>'
        +     '<div class="j_cart-rewards__text">' + renderText(reward.text, product, variant) + '</div>'
        +     renderVariantOptions(product)
        +   '</div>'
        +   '<button type="button" class="j_cart-rewards__btn t4s-btn" data-j-reward-add data-reward-key="' + escapeHtml(reward.key) + '" data-reward-flag="' + escapeHtml(reward.flag) + '" data-reward-label="' + escapeHtml(reward.cart_label || 'Reward') + '" data-variant-id="' + escapeHtml(variant.id) + '">Quick Add</button>'
        + '</div>';
    });

    els.offers.innerHTML = html;
  }

  function getRewardKeysToRemove(cart, total, config) {
    var keys = [];

    (cart.items || []).forEach(function (item) {
      var props = item.properties || {};
      var reward = null;

      if (!isRewardLine(item)) return;

      (config.rewards || []).forEach(function (r) {
        if (reward) return;

        if (
          props._j_reward_key === r.key ||
          props._j_reward_flag === r.flag ||
          isTrue(props[r.flag])
        ) {
          reward = r;
        }
      });

      if (!reward || reward.enabled !== true || total < Number(reward.amount || 0)) {
        if (item.key) keys.push(item.key);
      }
    });

    return keys;
  }

  function removeInvalidRewards(cart, total, config) {
    var keys;
    var chain = Promise.resolve();

    if (!window.JCartCore) return Promise.resolve(false);

    keys = getRewardKeysToRemove(cart, total, config);

    if (!keys.length) return Promise.resolve(false);

    keys.forEach(function (key) {
      chain = chain.then(function () {
        return window.JCartCore.changeItem({
          id: key,
          quantity: 0
        });
      });
    });

    return chain.then(function () {
      return true;
    });
  }

  function render(cart) {
    var els = getEls();
    var total;

    if (!els) return;

    if (isExcludedByDiscount(els.config)) {
      els.wrap.setAttribute('hidden', '');
      return;
    }

    els.wrap.removeAttribute('hidden');

    total = getSpendSubtotal(cart);

    return removeInvalidRewards(cart, total, els.config).then(function (removed) {
      var progress;
      var nextStep;

      if (removed) {
        queueRefresh(250);
        return;
      }

      progress = getProgress(total, els.config);
      nextStep = getNextStep(total, els.config);

      if (els.fill) {
        els.fill.style.width = progress + '%';
      }

      renderMarkers(total, els);

      if (els.msg) {
        if (nextStep) {
          els.msg.textContent = 'Spend ' + formatMoneyShort(Number(nextStep.amount) - total) + ' more to unlock ' + nextStep.label + '.';
        } else {
          els.msg.textContent = 'You have unlocked all available rewards.';
        }
      }

      renderOffers(cart, total, els);
    });
  }

  function addReward(button) {
    var variantId = button.getAttribute('data-variant-id');
    var rewardKey = button.getAttribute('data-reward-key');
    var rewardFlag = button.getAttribute('data-reward-flag');
    var rewardLabel = button.getAttribute('data-reward-label') || 'Reward';
    var props;

    if (!variantId || !window.JCartCore) return;

    props = {
      _j_reward: '1',
      _j_reward_key: rewardKey,
      _j_reward_flag: rewardFlag,
      _j_reward_variant: String(variantId),
      _j_reward_label: rewardLabel,
      _source: 'minicart'
    };

    if (rewardFlag) props[rewardFlag] = '1';

    button.disabled = true;

    window.JCartCore.addItem({
      id: variantId,
      quantity: 1,
      properties: props
    }).catch(function () {
      button.disabled = false;
    });
  }

  function bindEvents() {
    document.addEventListener('change', function (event) {
      var select = event.target.closest('[data-j-reward-variant]');
      var card;
      var button;

      if (!select) return;

      card = select.closest('[data-j-reward-card]');
      if (!card) return;

      button = card.querySelector('[data-j-reward-add]');
      if (!button) return;

      button.setAttribute('data-variant-id', select.value);
    });

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-j-reward-add]');
      if (!button) return;

      event.preventDefault();
      addReward(button);
    });

    document.addEventListener('cart:refresh', function () {
      queueRefresh(120);
    });

    document.addEventListener('j:cart:mutated', function () {
      queueRefresh(180);
    });
  }

  function refresh() {
    if (isSyncing) return;
    if (!window.JCartCore) return;

    isSyncing = true;

    window.JCartCore.getCart()
      .then(render)
      .catch(function () {})
      .finally(function () {
        isSyncing = false;
      });
  }

  function queueRefresh(delay) {
    if (refreshTimer) clearTimeout(refreshTimer);

    refreshTimer = setTimeout(function () {
      refresh();
    }, typeof delay === 'number' ? delay : 120);
  }

  document.addEventListener('DOMContentLoaded', function () {
    bindEvents();
    queueRefresh(50);
  });

  window.JCartRewards = {
    refresh: refresh,
    queueRefresh: queueRefresh
  };
})();